import ToggleButton from 'Components/Element/ToggleButton';
import { getEmailPrefApi, setEmailPrefApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import { Info } from 'lucide-react';
import { toast } from 'react-toastify';

//summarytype 0 - dailySummary
//summarytype 1 - weeklySummary
//summarytype 2 - daily and weekly summary
//summarytype 3 - noEmail

//triggertype 0 - immediateTrigger
//triggertype 1 - noEmail
//triggertype 2 - dailysummaryTrigger

//type 0 - accountEmail
//type 1 - noEmail

// One option row inside a settings box - label + hint on the left, toggle on the right.
function OptionRow({ label, hint, toggleOption, callbackFunc, disabled, first }) {
    return (
        <div
            className='flex items-center justify-between gap-4 font-plexsans'
            style={{ padding: '16px 20px', borderTop: first ? 'none' : '1px solid rgba(20,33,61,.08)' }}
        >
            <div>
                <div className='text-navy' style={{ fontWeight: 500, fontSize: '13.5px' }}>{label}</div>
                <div style={{ fontSize: '12.5px', lineHeight: 1.5, color: 'rgba(20,33,61,.5)' }}>{hint}</div>
            </div>
            <ToggleButton toggleOption={toggleOption} callbackFunc={callbackFunc} disabled={disabled} />
        </div>
    );
}

// A settings group - title, description, then one bordered box of option rows.
function SettingsGroup({ title, description, children }) {
    return (
        <div className='font-plexsans' style={{ marginBottom: '26px' }}>
            <div className='text-navy' style={{ fontWeight: 600, fontSize: '14.5px', marginBottom: '3px' }}>{title}</div>
            <div style={{ fontSize: '13px', lineHeight: 1.5, color: 'rgba(20,33,61,.5)', marginBottom: '12px' }}>{description}</div>
            <div className='bg-white' style={{ border: '1px solid rgba(20,33,61,.12)', borderRadius: '6px' }}>
                {children}
            </div>
        </div>
    );
}

function ProfEmailNotification() {
    const [toggleBtns, setToggleBtns] = useState({
        dailySummary: false,
        weeklySummary: false,
        immTrigger: false,
        summaryTrigger: false,
        accountEmail: true});

    const {userDetails, makeApiCallFunc} = useContext(Context);
    const locked = !userDetails.verified;

    useEffect(() => {
        makeApiCallFunc(getEmailPrefApi,
            {id: userDetails._id},
            ({data}) => {
                setToggleBtns({
                    dailySummary: data.summaryType === 0 || data.summaryType === 2,
                    weeklySummary: data.summaryType === 1 || data.summaryType === 2,
                    immTrigger: data.triggerType === 0,
                    summaryTrigger: data.triggerType === 2,
                    accountEmail: data.type === 0
                });
            }, (data) => console.log(data));
    },[userDetails._id])

    const changePref = () => {
        makeApiCallFunc(  setEmailPrefApi, {
            summaryType: toggleBtns.dailySummary && toggleBtns.weeklySummary ? 2 : toggleBtns.dailySummary ? 0 : toggleBtns.weeklySummary ? 1 : 3,
            triggerType: toggleBtns.summaryTrigger ? 2 : toggleBtns.immTrigger ? 0 : 1,
            type: toggleBtns.accountEmail ? 0 : 1,
            user: userDetails._id},
            ({data}) => {
                toast.success('Email preferences updated successfully');
            },
            (data) => console.log(data))
    }

  return (
    <div className="col-span-6 w-full px-2 lg:pl-4 h-full lg:pr-20">
      <div className='w-full h-full pt-6 lg:pt-8 pl-2 lg:pl-6 pb-10 font-plexsans'>
        <div className='font-spectral text-navy' style={{ fontWeight: 400, fontSize: '20px', marginBottom: '20px' }}>Email notifications</div>

        {locked &&
            <div
                className='flex items-start text-navy'
                style={{ gap: '10px', border: '1px solid rgba(138,98,49,.3)', background: 'rgba(138,98,49,.06)', borderRadius: '6px', padding: '16px 18px', marginBottom: '28px', fontSize: '13px', lineHeight: 1.55 }}
            >
                <Info size={15} strokeWidth={2} color="#8a6231" className='flex-none' style={{ marginTop: '2px' }} />
                <div>
                    Some preferences unlock once your firm is verified. Until then you'll automatically receive emails about your account approval — adjust that under Account-related email below.
                </div>
            </div>
        }

        {/* Summary + Case update groups stay locked until the firm is verified */}
        <div className={locked ? 'pointer-events-none' : ''} style={locked ? { opacity: .55 } : undefined} aria-disabled={locked}>
            <SettingsGroup title="Summary email" description={userDetails?.isActiveSubscription ? "A daily or weekly digest of the top cases matching your practice areas." : "A weekly digest of the top cases matching your practice areas."}>
                {userDetails?.isActiveSubscription &&
                    <OptionRow
                        first
                        label="Receive daily summary of top cases"
                        hint="Sent every day, based on your case type and state preferences."
                        toggleOption={toggleBtns.dailySummary}
                        disabled={locked}
                        callbackFunc={() => setToggleBtns((prev) => ({...prev, dailySummary: !prev.dailySummary}))}
                    />
                }
                <OptionRow
                    first={!userDetails?.isActiveSubscription}
                    label="Receive weekly summary of top cases"
                    hint="Sent once a week, based on your case type and state preferences."
                    toggleOption={toggleBtns.weeklySummary}
                    disabled={locked}
                    callbackFunc={() => setToggleBtns((prev) => ({...prev, weeklySummary: !prev.weeklySummary}))}
                />
            </SettingsGroup>

            <SettingsGroup title="Case update email" description="Choose how often you're notified about the cases you've requested to view.">
                <OptionRow
                    first
                    label="Daily digest"
                    hint="All updates consolidated into one email per day."
                    toggleOption={toggleBtns.summaryTrigger}
                    disabled={locked}
                    callbackFunc={() => setToggleBtns((prev) => ({...prev,
                        summaryTrigger: !prev.summaryTrigger,
                        immTrigger: !prev.summaryTrigger ? false : prev.immTrigger
                    }))}
                />
                <OptionRow
                    label="Immediate updates"
                    hint="Sent the moment there's an update — for time-sensitive cases."
                    toggleOption={toggleBtns.immTrigger}
                    disabled={locked}
                    callbackFunc={() => setToggleBtns((prev) => ({...prev,
                        immTrigger: !prev.immTrigger,
                        summaryTrigger: !prev.immTrigger ? false : prev.summaryTrigger
                    }))}
                />
            </SettingsGroup>
        </div>

        {/* Account-related email - highlighted, never locked */}
        <div
            className='flex items-start justify-between'
            style={{ gap: '20px', border: '1px solid rgba(138,98,49,.3)', background: 'rgba(138,98,49,.04)', borderRadius: '6px', padding: '18px 20px', marginBottom: '30px' }}
        >
            <div>
                <div className='text-navy' style={{ fontWeight: 600, fontSize: '14px', marginBottom: '5px' }}>Account-related email</div>
                <div style={{ fontSize: '12.5px', lineHeight: 1.55, color: 'rgba(20,33,61,.55)', maxWidth: '600px' }}>
                    Verification status, security alerts, and changes to your firm's account. We recommend keeping this on so you don't miss anything important — you can turn it off any time.
                </div>
            </div>
            <div style={{ marginTop: '2px' }}>
                <ToggleButton
                    toggleOption={toggleBtns.accountEmail}
                    onColor="#3a7d4f"
                    callbackFunc={() => setToggleBtns((prev) => ({...prev, accountEmail: !prev.accountEmail}))}
                />
            </div>
        </div>

        <button
            type="button"
            onClick={changePref}
            className='bg-tan hover:bg-tanDark text-ivory transition-colors'
            style={{ fontWeight: 500, fontSize: '13px', padding: '13px 30px', borderRadius: '3px' }}
        >
            Save email preferences
        </button>
      </div>
    </div>
  )
}

export default ProfEmailNotification;
